import { render, staticRenderFns } from "./Communicate.vue?vue&type=template&id=39ecadb4&scoped=true&"
import script from "./Communicate.vue?vue&type=script&lang=js&"
export * from "./Communicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ecadb4",
  null
  
)

export default component.exports